import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { microsoftLoginRequest } from "./msalConfig.js";

const MicrosoftLogo = () => (
  <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true">
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

const MicrosoftLoginButton = ({ onError, onAttempt, width }) => {
  const { instance } = useMsal();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) {
      return;
    }

    onAttempt?.();
    setIsLoading(true);
    try {
      await instance.loginRedirect(microsoftLoginRequest);
    } catch (error) {
      setIsLoading(false);
      onError(error);
    }
  };

  return (
    <button
      type="button"
      className="sso-button microsoft-login-button"
      style={{ width: width || "100%" }}
      onClick={handleClick}
      disabled={isLoading}
    >
      <MicrosoftLogo />
      <span>{t("Sign in with Microsoft")}</span>
    </button>
  );
};

export default MicrosoftLoginButton;
